var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17_6886)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17_6886",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17_6886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V23H37.2819V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9967 3H3V23H12.9967V3Z",
    fill: "#313F99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 12.9966H3V22.9933H37.2819V12.9966Z",
    fill: "#C22827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00167 5.49748L7.22498 7.87445L8.41681 8.2628L8.00167 5.49748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00168 5.49748L8.77168 7.87445L7.58655 8.2628L8.00168 5.49748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3786 7.22498H7.87445V8.47707L10.3786 7.22498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3786 7.22498L8.35652 8.69133L7.62 7.68028L10.3786 7.22498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62469 7.22498L7.64679 8.69133L8.37662 7.68028L5.62469 7.22498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62469 7.22498H8.12218V8.47707L5.62469 7.22498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.468 10.0171L8.698 7.64011L7.50616 8.02846L9.468 10.0171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46802 10.0171L7.44592 8.55072L8.18245 7.53967L9.46802 10.0171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52863 10.0171L8.55072 8.55072L7.8142 7.53967L6.52863 10.0171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52863 10.0171L7.30532 7.64011L8.49046 8.02846L6.52863 10.0171Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17_6886",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17_6886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17_6886",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChile);
export default __webpack_public_path__ + "static/media/Chile.cca1133c387226abc9eb7cedcbe87ec7.svg";
export { ForwardRef as ReactComponent };